import { getUrl, Request } from '../../request';

export const getConfig = (code) => Request.get(getUrl(`/api/v1/content/configs/${code}/`));
